import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const LOGIN_PATHS = ['/login']
const STORAGE_KEY = 'app-nav-entries'

type Entries = Record<number, string>

function readEntries(): Entries {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '{}') as Entries
  } catch {
    return {}
  }
}

function writeEntries(entries: Entries): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
  } catch {
    /* ha nincs storage, a gomb rejtve marad */
  }
}

function currentIndex(): number {
  const idx = (window.history.state as { idx?: number } | null)?.idx
  return typeof idx === 'number' ? idx : 0
}

export function useCanGoBack(): boolean {
  const location = useLocation()
  const [canGoBack, setCanGoBack] = useState(false)

  useEffect(() => {
    const idx = currentIndex()
    const entries = readEntries()
    entries[idx] = location.pathname
    writeEntries(entries)

    const previous = entries[idx - 1]
    setCanGoBack(idx > 0 && previous !== undefined && !LOGIN_PATHS.includes(previous))
  }, [location])

  return canGoBack
}
